import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import EditDocTalk from "./EditDocTalk";
import SalespersonSidebar from "./SalespersonSidebar";

const ViewDocTalk = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [savedData, setSavedData] = useState({});
  const navigate = useNavigate();
  const [toggle, setToggle] = useState(1);
          function updateToggle(aid) {
          setToggle(aid);
        
          if (aid === 1) {
            navigate(`/doc-talk-mentors/${nid}/view`);
          }
        
          if (aid === 2) {
            navigate(`/doc-talk-mentors/${nid}/edit`);
          }
        }
  const[error,setError] = useState({});
   var {nid} = useParams();
   const {tab} = useParams();
             const location  = useLocation();
              if(location.state) {
              nid = location.state;
              }
             
              const app_url = configData.APP_URL;
  const getFileIcon = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();

    switch (extension) {
      case 'txt':
        return '/images/text-plain.png';
      case 'pdf':
        return '/images/application-pdf.png';
      case 'docx':
        return '/images/x-office-document.png'; 
      case 'jpg':
      case 'jpeg':
        return '/images/image-x-generic.png';
      case 'xls':
      case 'xlsx':
        return '/images/x-office-spreadsheet.png';
      case 'csv':
        return '/images/text-x-generic.png';
      case 'mp4':
        return '/images/video-x-generic.png';
      case 'png':
        return '/images/image-x-generic.png';
      default:
        return '/images/image-x-generic.png';
    }
  };

 const getFullFileUrl = (path) => {
  console.log("getFullFileUrl received:", path);

  // If it's a File object, create a temporary object URL
  if (path instanceof File) {
    return URL.createObjectURL(path);
  }

  // If it's not a string, return an empty string
  if (!path || typeof path !== "string") return "";

  // If it's already a full URL, return it as is
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  // Assume it's a relative path on the server
  const baseUrl = window.location.origin;
  return `${baseUrl}/${path}`;
};


 useEffect(() => {
    
     Promise.all([
           retrivedoctalkdetails()
          ]).then(() => {
     
            setIsLoading(false);
           
          })
       
    
    
     
   },[]);
async function retrivedoctalkdetails() {
    try {
        const response = await fetch(
        app_url+'doctalk/getmanagedoctalkdetails?nid='+nid,
        {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
        }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg === "Success") {
            setSavedData(responsedata.data.result);
            
        }
    }catch (err) {
        setError({
            text:"Error in loading Content"
        }); // Catch network errors or errors thrown from !response.ok
      }

  
  }
  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
            <div>
        
          <div className="view-doctalk-container">
          {/* Mentor Name */}
          {savedData.title && (
            <>
              <div><strong>Mentor Name:</strong></div>
              <div>{savedData.title}</div>
            </>
          )}

          {/* Summary */}
          {savedData.summary && (
            <>
              <div style={{ marginTop: "1em" }}><strong>Summary:</strong></div>
              <div dangerouslySetInnerHTML={{ __html: savedData.summary }} />
            </>
          )}

          {/* Body */}
          {savedData.body && (
            <>
              <div style={{ marginTop: "1em" }}><strong>Body:</strong></div>
              <div dangerouslySetInnerHTML={{ __html: savedData.body }} />
            </>
          )}

          {/* Mentor Image */}
                {savedData.mentors?.length > 0 && (
  <>
    <div style={{ marginTop: "1em" }}>
      <strong>Doc Talk Mentor Image:</strong>
    </div>

    <div style={{ marginTop: "0.5em" }}>
      {savedData.mentors.map((mentor) => (
        mentor.field_doc_talk_mentor_image && (
          <img
            key={mentor.id}
            src={mentor.field_doc_talk_mentor_image}
            alt={mentor.mentor_name}
            style={{
              maxWidth: "100%",
              height: "auto",
              marginBottom: "10px",
            }}
          />
        )
      ))}
    </div>
  </>
)}

          
          {/* Zoom Video Link */}
          {savedData.videoLink && (
            <>
              <div style={{ marginTop: "1em" }}><strong>Zoom Video Recording Link:</strong></div>
              <a
                href={savedData.videoLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                {savedData.videoLink}
              </a>
            </>
          )}

          {/* Zoom Audio Link */}
          {savedData.audioLink && (
            <>
              <div style={{ marginTop: "1em" }}><strong>Zoom Audio Recording Link:</strong></div>
              <a
                href={savedData.audioLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                {savedData.audioLink}
              </a>
            </>
          )}

          {/* Chat Time */}
          {savedData.field_doc_talk_chat_time && (
            <>
              <div style={{ marginTop: "1em" }}><strong>Doc Talk Chat Time:</strong></div>
              <div>{savedData.field_doc_talk_chat_time}</div>
            </>
          )}
          {/* Chat Time */}
          {savedData.field_zoom_chat_link && (
            <>
              <div style={{ marginTop: "1em" }}><strong>Zoom Chat Link:</strong></div>
              <div>{savedData.field_zoom_chat_link}</div>
            </>
          )}
          {/* Chat Time */}
          {savedData.field_passcode && (
            <>
              <div style={{ marginTop: "1em" }}><strong>Passcode:</strong></div>
              <div>{savedData.field_passcode}</div>
            </>
          )}
          {/* Chat Time */}
          {savedData.field_form_frontend_title && (
            <>
              <div style={{ marginTop: "1em" }}><strong>Form Frontend Title:</strong></div>
              <div dangerouslySetInnerHTML={{ __html: savedData.field_form_frontend_title }} />
            </>
          )}
        </div>
        </div>
      )}
    </>
  );
};

export default ViewDocTalk;
